/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = 1147;
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/*
 * Globals
 ***************************/
  /* Window */
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    let isMobile = ( windowWidth <= mobileBreakpoint );
  /* Navigation */
    let isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, Flip);

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

//Brush Animation Scripts


// var animation = bodymovin.loadAnimation({
//     container: document.getElementById('bm'),
//     renderer: 'svg',
//     loop: true,
//     autoplay: true,
//     path: g7Vars.templateURL+'/js/brushes/bodymovin.json'
//   })

//get all underlines.
 
 lottie.setLocationHref(window.location.href)
 
 if ( $('s').length ) {
   $.getJSON(g7Vars.lottieFolder + 'circle.json', {}, function(circleAnimation){
     console.log(circleAnimation);
     
     $('s').each(function(){
       const parent = $(this).closest('.wp-block-heading').get(0);
       const animData = Object.assign({}, circleAnimation);
       const split = new SplitText(parent, {
         type: 'lines,words',
         linesClass: 'split-line',
         wordsClass: 'split-word',
         tag: 'span'
       });
       
       $(this).addClass('circle');
        
       const circle = lottie.loadAnimation({
         container: this,
         renderer: 'svg',
         autoplay: false,
         animationData: animData,
         loop: false,
       });
       
       
       circle.setSpeed(2);
       
       ScrollTrigger.create({
        trigger: this,
         start: 'top bottom',
         endTrigger: 'body',
         end: 'bottom top',
         onEnter: () => {
            circle.play();
          },
         onLeaveBack: () => {
           circle.stop();
         }
       })
      });
   });
 }
 
 if ( ('.wp-block-heading span[style*="text-decoration: underline"]').length ) {
   $.getJSON(g7Vars.lottieFolder + '_Purple_Underline_Stroke.json', {}, function(underlineAnimation){
      $('.wp-block-heading [style*="text-decoration: underline"]').each(function(){
        const parent = $(this).closest('.wp-block-heading').get(0);
        const animData = Object.assign({}, underlineAnimation);
        
        $(this).addClass('underline');
        
        const split = new SplitText(parent, {
           type: 'lines,words',
           linesClass: 'split-line',
           wordsClass: 'split-word',
           tag: 'span'
         });
         
         const underline = lottie.loadAnimation({
            container: this,
            renderer: 'svg',
            autoplay: false,
            animationData: animData,
            loop: false,
          });
          
          underline.setSpeed(2);
          
          ScrollTrigger.create({
           trigger: this,
            start: 'top bottom',
            endTrigger: 'body',
            end: 'bottom top',
            onEnter: () => {
               underline.play();
             },
            onLeaveBack: () => {
              underline.stop();
            }
          })
      });
    });
   
 }
 
 if ( $('.header-block.is-style-fullscribble .page-header').length ) {
   $.getJSON(g7Vars.lottieFolder + 'Zigzag_stroke_Yellow.json', {}, function(zigzagAnimation){
     $('.header-block.is-style-fullscribble .page-header').each(function(){
       const animData = Object.assign({}, zigzagAnimation);
       
       const zag = lottie.loadAnimation({
         container: this,
         renderer: 'svg',
         autoplay: true,
         animationData: animData,
         loop: false
       });
     });
   });
 }
  
 
  
  
  
  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header__nav').length ) {
    const navResizeAction = (updated, updatedWidth) => {
      if ( updated ) {
        if ( isMobile ) {
          $('#site-nav').attr('role', 'dialog');
          $('#site-nav').attr('aria-modal', 'true');
        } else {
          const navEl = $('#site-nav').get(0);
          navEl.removeAttribute('role');
          navEl.removeAttribute('aria-modal');
        }
      }
    };

    navResizeAction(true);
    windowResizeActions.push(navResizeAction);

    const mobileNavContainer = $('.site-header__nav-inner');
    const mobileToggle = $('.site-header__nav-toggle');
    const mobileDismiss = $('.site-header__nav-dismiss');
    const firstFocusableMenuElement = $(mobileNavContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    if ( $(mobileNavContainer).find('.menu-item-has-children') ) {
      $(mobileNavContainer).find('.menu-item-has-children').each(function(){
        const toggle = $(this).children('a, button');
        const submenu = $(this).children('.sub-menu')

        let target = $(toggle).attr('aria-controls');
        let expanded = $(toggle).attr('aria-expanded');

        const toggleResizeAction = (updated) => {
          if ( updated ) {
            if ( isMobile ) {
              $(toggle).attr('aria-controls', target);
              $(toggle).attr('aria-expanded', expanded);
            } else {
              $(toggle).get(0).removeAttribute('aria-controls');
              $(toggle).get(0).removeAttribute('aria-expanded');
            }
          }
        };
        toggleResizeAction(true);

        toggle.on('click', function(e){
          if ( isMobile ) {
            e.preventDefault();
            expanded = expanded == 'true' ? 'false' : 'true';
            $(toggle).attr('aria-expanded', expanded);
            console.log(submenu);
            submenu.slideToggle();
          }
        }).on('keypress', handleKeypressADA);
      });
    }

    $('.site-header__nav-toggle').on('click', function(){
      $(this).toggleClass('active');
      if ( $(this).hasClass('active') ) {
        $(mobileNavContainer).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          onComplete: function(){
            $(mobileNavContainer).focus();
          }
        });
      } else {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      }
    }).on('keypress', handleKeypressADA);

    $(mobileDismiss).on('click', function(){
      if ( isMobile ) {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        $(mobileToggle).removeClass('active');
        $(mobileToggle).focus();
      }
    }).on('keypress', handleKeypressADA);

    $(mobileNavContainer).on('keydown', function(e){
      if ( isMobile ) {
        if ( e.key == 'Escape' ) {
          mobileDismiss.click();
        } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });
    
    const contactModal = $('.site-header__nav__button-modal');
    const contactToggle = $('.site-header__nav__button-button');
    let contactModalIsAnimating = false;
    
    const closeModal = () => {
      contactModalIsAnimating = true;
      gsap.to(contactModal, {
        x: '100%',
        duration: 0.8,
        ease: 'power3.inOut',
        onComplete: function() {
          $(contactModal).css({
            'pointer-events': 'none',
            'visibility': 'hidden'
          })
          
          $(contactToggle).focus();
          contactModalIsAnimating = false;
        }
      });
    }
    
    const openModal = () => {
      contactModalIsAnimating = true;
      $(contactModal).css({
        'pointer-events': 'auto',
        'visibility': 'visible'
      })
      
      gsap.to(contactModal, {
        x: 0,
        duration: 0.8,
        ease: 'power3.inOut',
        onComplete: function() {
          contactModalIsAnimating = false;
        }
      });
    }
    
    $(contactToggle).on('click', function(){
      if ( contactModalIsAnimating === false ) {
        $(this).toggleClass('active');
        if ( $(this).hasClass('active') ) {
          openModal();
        } else {
          closeModal();
        }
      }
    });
    
    $('.site-header__nav__button-modal-dismiss').on('click', function(){
      contactToggle.removeClass('active');
      closeModal();
    });
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  // gallery
  $(document).ready(function () {
    if ( $('.wp-block-gallery').length ) {
      $('.wp-block-gallery').each(function(){
        gutenbergSlickify(this);
      });
    }
  });

//headerblock
  if($(".header-carousel").length){
  
    $('.header-carousel').each(function(){
      const images = $(this).find('.header-carousel__images');
      const controls = $(this).find('.header-carousel__controls');
      const curNum = controls.find('.header-carousel__controls-nums-cur');
      const words = $(this).data('words');
      const highlightedWord = $(this).find('.header-carousel__text-inner-highlight').get(0);
      const lineContainer = $(this).find('.header-carousel__line');
      const autoplayInd = $(this).find('.header-carousel__autoplay-indicator');
      const autoplayButton = $(this).find('.header-carousel__controls-autoplay');
      const isGallery = $(this).find('.header-carousel__images-image').length > 0;
      const hasBgVideo = $(this).find('.header-carousel__images-video video').length > 0;
      const bgVideo = this.querySelector('.header-carousel__images-video video');
      let line = false;
      let doneLoadingAnim = false;
      let wordIndex = 0;
      
      const hasVideoModal = $(this).find('.header-carousel__fullvideo-trigger').length > 0;
      const modalTrigger = $(this).find('.header-carousel__fullvideo-trigger');
      const modalDismiss = $(this).find('.header-carousel__fullvideo-modal__dismiss');
      const modal = $(this).find('.header-carousel__fullvideo-modal');
      
      if ( hasVideoModal ) {
        const fullVideo = modal.get(0).querySelector('video, .header-carousel__fullvideo-modal__inner-embed');
        window.localStorage.removeItem("plyr")
        const player = new Plyr(fullVideo, {
          hideControls: false,
          autoplay: false,
          muted: false,
          playsinline: true,
          loop: {
            active: false
          }
        });
        
        modalTrigger.on('click', function(){
          gsap.set(modal, {
            'visibility': 'visible',
            'pointer-events': 'auto',
            'opacity': 0
          });
          
          gsap.to(modal, {
            opacity: 1,
            duration: 0.5,
            onComplete: function() {
              player.play();
            }
          });
        });
        
        modalDismiss.on('click', function(){
          player.pause();
          
          gsap.to(modal, {
            opacity: 0,
            duration: 0.5,
            onComplete: function() {
              gsap.set(modal, {
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
            }
          });
        });
      }
      
      if ( lineContainer.length ) {
        $.getJSON(g7Vars.lottieFolder + '_Yellow_Accent_Stroke.json', {}, function(lineAnimation){
          line = lottie.loadAnimation({
             container: lineContainer.get(0),
             renderer: 'svg',
             autoplay: false,
             animationData: lineAnimation,
             loop: false,
             rendererSettings: {
               preserveAspectRatio: 'none'
             }
           });
           
           if ( doneLoadingAnim ) {
             line.play();
           }
        });
      }
      
      
      const startWords = $(this).find('.word');
      const introTL = gsap.timeline({
        repeat: false,
        paused: true
      });
      
      gsap.set(startWords, {
        y: '100%'
      });
      
      introTL.to({}, {
        y: 0,
        duration: 0.3
      })
      
      introTL.to(startWords, {
        y: '0',
        duration: 0.6,
        stagger: 0.05,
        ease: 'power3.inOut'
      });
      
      if ( isGallery ) {
        images.slick({
          appendArrows: controls.find('.header-carousel__controls-left'),
          fade: true,
          swipe: false
        });
      }
     
      
      const autoplayTL = gsap.timeline({
        repeat: -1,
        paused: true,
        onRepeat: () => {
          if ( isGallery ) {
            $(images).slick('slickNext');
          } else {
            wordIndex++;
            wordIndex = wordIndex % words.length;
            changeWord(wordIndex);
          }
        }
      });
      
      
      if ( autoplayInd.length ) {
        autoplayTL.to(autoplayInd, {
          scaleX: 1,
          duration: 5,
          ease: 'linear'
        });
      } else {
        autoplayTL.to({
          x: 0
        }, {
          x: 1,
          duration: 5,
          ease: 'linear'
        });
      }
      
      
      const landingAnimation = document.querySelector(".landing-animation");
      if ( landingAnimation !== null ) {
        $(".site-header__logo, .site-header__inner").one('transitionend', function() {
          if ( doneLoadingAnim === false ) {
            doneLoadingAnim = true;
            introTL.play();
            autoplayTL.play();
            if ( line !== false ) {
              line.play();
            }
          }
        });
      } else {
        doneLoadingAnim = true;
        introTL.play();
        autoplayTL.play();
      }
      
      let autoplaying = true;
      
      autoplayButton.on('click', function(){
        autoplaying = !autoplaying;
        if ( autoplaying ) {
          autoplayTL.play();
          if ( hasBgVideo ) {
            bgVideo.play();
          }
          $(this).find('.pause').show();
          $(this).find('.play').hide();
        } else {
          autoplayTL.pause();
          if ( hasBgVideo ) {
            bgVideo.pause();
          }
          $(this).find('.pause').hide();
          $(this).find('.play').show();
        }
      });
      
      const changeWord = function(nextSlide) {
        autoplayTL.seek(0);
        const word = words[nextSlide];
        const curWord = highlightedWord.querySelectorAll('.word');
        const span = document.createElement('span');
        span.classList.add('header-carousel__text-inner-highlight-word');
        span.classList.add('word');
        span.textContent = word;
        
        curNum.text(((nextSlide + 1) + '').padStart(2, '0'));
        
        highlightedWord.append(span);
        $(span).css({
          'position': 'absolute'
        });
        
        gsap.set(span, {
          y: '100%'
        });
        
        const tl = gsap.timeline({
          repeat: false,
          paused: true,
          onComplete: function() {
            for ( let i = 0; i < curWord.length; i++ ) {
              curWord[i].remove();
            }
            gsap.set(span, {
              clear: 'y'
            });
            
            $(span).css({
              'position': 'relative'
            });
          }
        });
        
        tl.to(span, {
          y: 0,
          duration: 0.6,
          ease: 'power3.inOut'
        }, 0);
        
        tl.to(curWord, {
          y: '-100%',
          duration: 0.6,
          ease: 'power3.inOut'
        }, 0);
        
        tl.play();
      };
      
      images.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        changeWord(nextSlide);
      });
    });
  }
  
  if ( $('.split-content__block').length ) {
    $('.split-content__block').each(function(){
      $(this).on('mouseenter', function(){
        $(this).closest('.block-wrapper').addClass('expanded');
        
        gsap.set($(this).closest('.block-wrapper'), {
          zIndex: $('.block-wrapper.transitioning').length ? parseInt(document.querySelector('.block-wrapper.transitioning').style.zIndex) + 1 : 2
        });
      })
      
      $(this).on('mouseleave', function() {
        
        $(this).closest('.block-wrapper').addClass('transitioning');
        
        $(this).one('transitionend', function(){
          
          $(this).closest('.block-wrapper').removeClass('transitioning');
          
          gsap.set($(this).closest('.block-wrapper'),{
            clearProps: 'zIndex'
          });
        });
        
        $(this).closest('.block-wrapper').removeClass('expanded');
      })
    });
  }
  
  //accordion
  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }
  
  
  //accordion with images
  if($(".accordion.is-style-has-images").length && $(".accordion.is-style-has-images").parent().hasClass('wp-block-column') ){
    var nextCol = $(".accordion.is-style-has-images").parent().next();
    $(nextCol).addClass('has-companion-images');
  console.log("we have an image accordion!");
  
  
  //loop through inners and get images
  var first = true;
    $('.accordion.is-style-has-images .accordion-inner').each(function(i,item){

      var divid = $(item).attr('id');
     var image = $(item).find(".accordion-inner__content .wp-block-image:first-of-type");
     $(image).attr('id','image-'+divid);
     $(image).addClass("accordion-image");
if(first){
  $(image).addClass("active");
       first = false
     }
     console.log(image);
     $(nextCol).append(image);
     var toggles = $(this).find('.accordion-inner__title button');
     toggles.on('mouseover', function(){
       $(".wp-block-image.accordion-image.active").removeClass("active");
       $("#image-"+divid).addClass("active");
       }).on('keypress', handleKeypressADA);

    });
    
  }
  /* END GUTENBERG SCRIPTS */
  
  if ( $('.content-card.has-fun-fact').length ) {
    $('.content-card.has-fun-fact').each(function(){
      let canholder = false;
      const thisRef = this;
      const img = $(this).find('.content-card__image > img');
      $(this).find('.content-card__image').on('mouseenter', function(){
        const can = createGraphics(1024, 1024);
        canvasProxies.push(can);
        $(this).find('.content-card__image-funfact').append('<div class="gradient-proxy"></div>');
        $(this).find('.gradient-proxy').append(can.elt);
        setTransforms();
        canholder = can;
      }).on('mouseleave', function() {
        img.one('transitionend', function(){
          // console.log("REMOVING!!!!");
          // console.log(canvasProxies.indexOf(canholder));
          canvasProxies.splice(canvasProxies.indexOf(canholder), 1);
          $(thisRef).find('.gradient-proxy').remove();
          canholder.remove();
        });
      });
    });
  }

//mnarquee block scripts

  if ( $('.services-marquee').length ) {
      $('.services-marquee').each(function(){
        const rows = $(this).find('.services-marquee__strip');
        rows.each(function(index){
          const direction = index % 2 == 0 ? -1 : 1;
          const tickerOuter = $(this);
          const tickerText = $(this).find('.services-marquee__strip-inner');
          let tickerItems = $(this).find('.services-marquee__strip-item');
          let tickerAnim = gsap.timeline();
          const setupAnim = () => {
            tickerAnim.pause();
            tickerAnim.progress(0);
            tickerAnim.clear();
            $(tickerOuter).find('.services-marquee__strip-item[aria-role="presentation"]').remove();
            $(tickerText).css('width', 'auto');
            tickerItems = $(tickerOuter).find('.services-marquee__strip-item');
            let totalWidth = 0;
              let tickerWidth = $(window).width();
              let itCount = 0;
    
              const cssReset = {};
              if ( direction == -1 ) {
                cssReset.left = totalWidth + 'px';
              } else {
                cssReset.right = totalWidth + 'px';
              }
    
              $(tickerItems).css(cssReset);
              let animWidth = 0;
    
    
              while ( totalWidth < tickerWidth * 4 || itCount <= 1 ) {
                $(tickerItems).each(function(index){
                  const cssObj = {};
                  // console.log(totalWidth);
                  if ( direction == -1 ) {
                    cssObj.left = totalWidth + 'px';
                  } else {
                    cssObj.right = totalWidth + 'px';
                  }
    
                  if ( itCount > 0 ) {
                    tickerText.append(tickerItems.eq(index).clone().css(cssObj).attr('aria-role', 'presentation'));
                  } else {
                    tickerText.append(tickerItems.eq(index).clone().css(cssObj));
                  }
    
                  totalWidth += tickerItems.eq(index).outerWidth();
                });
    
                if ( itCount == 0 ) {
                  animWidth = totalWidth;
                }
    
                itCount++;
              }
    
              $(tickerText).css('width', totalWidth + 'px');
    
              $(tickerItems).remove();
    
              tickerAnim = gsap.timeline({
                repeat: -1
              });
              
    
              tickerAnim.to(tickerOuter.find('.services-marquee__strip-inner'), {
                x:  (animWidth * direction) + 'px',
                overwrite: true,
                ease: 'none',
                duration: isMobile ? (animWidth / 30) : (animWidth / 90)
              });
          };
          
          const animResizeAction = (updated, updatedWidth) => {
            if ( updatedWidth ) {
              setupAnim();
            }
          };
          
          animResizeAction(true, true);
          windowResizeActions.push(animResizeAction);
        });
      });
    }

    // LOGO CAROUSEL
    $(document).ready(function () {
      if ( $('.logo-carousel').length ) {
        $('.logo-carousel').each(function() {
          const strip = $(this).find('.logos');
          const clone = strip.clone(false);
          clone.attr('aria-hidden', 'true');
          $(this).append(clone);
          gsap.set(clone, {
            x: '100%'
          });
          
          const loop = gsap.timeline({
            repeat: -1
          });
          
          loop.to(strip, {
            x: '-=100%',
            ease: 'linear',
            duration: () => {
              return isMobile ? windowWidth / 13 : windowWidth / 30;
            }
          });
          
          loop.to(clone, {
            x: '-=100%',
            ease: 'linear',
            duration: () => {
              return isMobile ? windowWidth / 13 : windowWidth / 30;
            }
          }, '0');
        });
      }
    });

    

    /* ARCHIVE BLOCK SCRIPTS */
    if ( $('.archive-block').length ) {
      $('.archive-block').each(function(){
        const archiveBlock = $(this);
        const archiveFeed = $(this).find('.archive-block__feed');
        const archivePagination = $(this).find('.archive-block__pagination-container');

        const archiveFilterForm = $(this).find('.archive-block__header');
        const archiveSortInputs = $(this).find('.archive-block__sort-radio-input');
        const archiveSearchInput = $(this).find('.archive-block__search-input');
        const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

        const archiveFilterGroups = $(this).find('.archive-block__filter');


        const base = $(this).data('baseurl');
        let currentURL = $(this).data('currenturl');
        const initPage = $(this).data('page');
        const postType = $(this).data('posttype');
        const exclude = $(this).data('exclude');

        let updateArchive;
        let stateObj = {
          base: base,
          url: currentURL,
          page: initPage,
          sort: 'default',
          postType: postType,
          search: false,
          exclude: exclude,
          filters: {}
        };

        if ( this.hasAttribute('data-postsper') ) {
          stateObj.postsPerPage = $(this).data('postsper');
        }

        if ( this.hasAttribute('data-cardargs') ) {
          stateObj.cardArgs = $(this).data('cardargs');
        }

        const updateURLFromFilters = () => {
          const baseurl = base[0] === '/' ? window.location.protocol + base : base;
          const url = new URL(baseurl);
          if ( stateObj.sort !== 'default' ) {
            url.searchParams.append('sort', 'sort-' + stateObj.sort);
          }

          if ( stateObj.search !== false ) {
            url.searchParams.append('search', stateObj.search);
          }

          if ( Object.keys(stateObj.filters).length ) {
            for ( const filterType in stateObj.filters ) {
              if ( Array.isArray(stateObj.filters[filterType]) ) {
                url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
              } else {
                url.searchParams.append(filterType, stateObj.filters[filterType]);
              }
            }
          }

          stateObj.url = url.toString();
          stateObj.page = 1;

          updateArchive();
        };

        if ( archiveFilterGroups.length ) {
          $(archiveFilterGroups).each(function() {
            const inputs = $(this).find('input');
            const indicator = document.createElement('span');
            indicator.classList.add('archive-block__filter-input__label-indicator');

            const mobileToggle = $(this).find('.archive-block__filter-toggle');
            const mobileDropdown = $(this).find('.archive-block__filter-list');

            mobileToggle.on('click', function(){
              if ( true ) { // set to isMobile to make responsive
                $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true' );

                if ( $(this).attr('aria-expanded') == 'true' ) {
                  $(mobileDropdown).css({
                    'visibility': 'visible',
                    'pointer-events': 'auto'
                  });
                  gsap.to(mobileDropdown, {
                    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
                  });
                } else {
                  gsap.to(mobileDropdown, {
                    clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
                    onComplete: function(){
                      $(mobileDropdown).css({
                        'visibility': 'hidden',
                        'pointer-events': 'none'
                      });
                    }
                  })
                }
              }
            }).on('keypress', handleKeypressADA);

            $(inputs).each(function(){
              const name = $(this).attr('name');
              const type = $(this).attr('type');
              const val = $(this).attr('value');

              if ( $(this).is(':checked') ) {
                const label = $(this).siblings('.archive-block__filter-input__label').get(0);
                label.appendChild(indicator);

                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  if ( stateObj.filters.hasOwnProperty(name) ) {
                    stateObj.filters[ name ].push( val );
                  } else {
                    stateObj.filters[ name ] = [ val ];
                  }
                }
              }

              $(this).on('change', function(){
                if ( $(this).is(':checked') ) {
                  const state = Flip.getState(indicator);
                  const label = $(this).siblings('.archive-block__filter-input__label').get(0);
                  label.appendChild(indicator);
                  Flip.from(state, {
                    absolute: true,
                    duration: 0.6,
                    ease: 'back.inOut',
                  });

                  $(mobileToggle).find('.archive-block__filter-toggle__current').text( label.textContent );

                  if ( type === 'radio' ) {
                    stateObj.filters[ name ] = val;
                  } else {
                    stateObj.filters[ name ].push( val );
                  }
                } else if ( type === 'checkbox' ) {
                  stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
                }
                updateURLFromFilters();

                if ( true ) { // change to isMobile to make responsive
                  $(mobileToggle).attr('aria-expanded', 'false');
                  gsap.to(mobileDropdown, {
                    clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
                    onComplete: function(){
                      $(mobileDropdown).css({
                        'visibility': 'hidden',
                        'pointer-events': 'none'
                      });
                    }
                  });
                }
              });
            });
          });
        }

        if ( archiveSortInputs.length ) {
          const toggle = $(this).find('.archive-block__sort-toggle');
          const dropdown = $(this).find('.archive-block__sort-dropdown');
          const toggleHint = $(toggle).find('.archive-block__sort-toggle__current');

          const toggleDropdown = (state) => {
            if ( state ) {
              $(dropdown).css({
                'visibility': 'visible',
                'pointer-events': 'auto'
              });

              gsap.to(dropdown, {
                clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
              });
            } else {
              gsap.to(dropdown, {
                clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
                onComplete: function(){
                  $(dropdown).css({
                    'visibility': 'hidden',
                    'pointer-events': 'none'
                  });
                }
              });
            }
          };

          $(toggle).on('click', function(){
            const oldState = $(this).attr('aria-expanded') == 'true';
            $(this).attr('aria-expanded', oldState ? 'false' : 'true');
            toggleDropdown(!oldState);
          }).on('keypress', handleKeypressADA);

          if ( $('.archive-block__sort-radio-input:checked' ).length ) {
            stateObj.sort = $('.archive-block__sort-radio-input:checked' ).data('sortkey');
          }

          $(archiveSortInputs).on('change', function(){
            stateObj.sort = $('.archive-block__sort-radio-input:checked' ).data('sortkey');
            $(toggle).attr('aria-expanded', 'false');
            toggleDropdown(false);
            updateURLFromFilters();
            $(toggleHint).text( $(this).next().text() );
          });
        }

        if ( archiveSearchInput.length ) {
          if ( archiveSearchInput.val() !== '' ) {
            stateObj.search = archiveSearchInput.val();
          }
        }

        if ( archiveSearchConfirm.length ) {
          archiveSearchConfirm.on('click', function(){
            const searchQuery = archiveSearchInput.val();
            if ( searchQuery !== '' ) {
              if ( stateObj.search !== searchQuery ) {
                stateObj.search = searchQuery;
              }

              updateURLFromFilters();
            } else {
              if ( stateObj.search !== false ) {
                stateObj.search = false;
                updateURLFromFilters();
              }
            }
          }).on('keypress', handleKeypressADA);
        }

        if ( archiveFilterForm.length ) {
          archiveFilterForm.on('submit', function(e){
            e.preventDefault();
            if ( archiveSearchConfirm.length ) {
              archiveSearchConfirm.trigger('click');
            }
          });
        }



        $(archivePagination).on('click', 'a', function(e){
          e.preventDefault();
          if ( ajaxIsLoading === false ) {
            const url = $(e.target).attr('href');
            let page = 1;
            const urlparts = url.split('?')[0].split('/');
            let parsedNum = false;
            for ( let i = urlparts.length - 1; i >= 0; i-- ) {
              if ( urlparts[ i ] != '' ) {
                const parsed = parseInt( urlparts[ i ] );
                if ( !isNaN(parsed) ) {
                  parsedNum = parsed;
                  break;
                }
              }
            }

            if ( parsedNum !== false ) {
              page = parsedNum;
            }

            console.log(page);


            stateObj.url = url;
            stateObj.page = page;

            updateArchive();
          }
        }).on('keypress', 'a', function(e){
          e.preventDefault();
          $(this).trigger('click');
        });

        const initState = stateObj;

        window.addEventListener('popstate', function(event){
          if ( Object.keys(event.state).length == 0 ) {
            stateObj = initState;
          } else {
            stateObj = event.state;
          }

          updateArchive(true);
        });


        updateArchive = (frompopstate = false) => {
          ajaxIsLoading = true;
          $(archiveBlock).addClass('loading');
          gsap.to(window, {
            scrollTo: archiveBlock.get(0),
            duration: 0.8,
            ease: 'power1.inOut'
          });


          if ( frompopstate === false ) {
            history.pushState(stateObj, '', stateObj.url);
          }

          const args = {
            paged: stateObj.page,
            base: stateObj.base,
            sort: stateObj.sort,
            postType: stateObj.postType,
            exclude: stateObj.exclude
          };

          if ( stateObj.search !== false ) {
            args.search = stateObj.search;
          } if ( stateObj.hasOwnProperty('postsPerPage') ) {
            args.postsPerPage = stateObj.postsPerPage;
          } if ( stateObj.hasOwnProperty('cardArgs') ) {
            args.cardArgs = stateObj.cardArgs;
          } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
            args.filters = stateObj.filters;
          }

          console.log(args);

          $.post(g7Vars.ajaxURL, {
            action: 'g7_get_archive',
            args: args
          }, function(data) {
            console.log(data);
            try {
              const res = JSON.parse(data);
              const state = Flip.getState( archiveFeed.get(0).querySelector('li') );
              $(archiveFeed).html( res.results );
              $(archivePagination).html( res.pagination );

              Flip.from(state, {
                absolute: true,
                duration: 0.6,
                onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
                onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
              });
            } catch (err) {
              console.log( err );
            }
          }).always(function(){
            $(archiveBlock).removeClass('loading');
            ajaxIsLoading = false;
          });
        };
      });
    }
    /* END ARCHIVE BLOCK SCRIPTS */
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  let updatedWidth = windowWidth != $(window).width();
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  isMobile = ( windowWidth <= mobileBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated, updatedWidth);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/
function gutenbergSlickify(el) {
  const count = $(el).find('figure').length;

  const captions = [];

  $(el).find('figure').each(function(){
    if ( $(this).find('figcaption').length ) {
      $(this).addClass('has-caption');
      captions.push( $(this).find('figcaption').clone(true) );
      $(this).find('figcaption').remove();
    } else {
      captions.push('<div style="height:10px;"></div>');
    }
  });

  $(el).find('.blocks-gallery-item').each(function(){
    $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
  });

  $(el).find('.blocks-gallery-item__caption').each(function(){
    $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
  });

  $(el).addClass('slick-gallery-grid').removeClass('blocks-gallery-grid');

  // $(el).parent().addClass('slick-gallery').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> of <b>' + count +'</b></div></div>');

  $(el).removeClass('wp-block-gallery').wrap('<div></div>');
  const parent = $(el).parent();
  parent.addClass('slick-gallery').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__inner"><div class="slick-gallery-nav__captions-outer"><div class="slick-gallery-nav__captions"></div></div><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> of <b class="secondNum">' + count +'</b></div></div>');


  const nav = $(el).parent().find('.slick-gallery-nav');
  const captionsContainer = nav.find('.slick-gallery-nav__captions');


  $(el).imagesLoaded(function () {
    captionsContainer.slick({
      adaptiveHeight: true,
      arrows: false,
      swipe: false,
      fade: true,
      infinite: true,
    });

    $(el).slick({
      adaptiveHeight: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      appendArrows: nav,
      asNavFor: captionsContainer,
      dots: false,
    });

    $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var formattedNextSlide = (nextSlide < 9) ?  + (nextSlide + 1) : (nextSlide + 1);
      nav.find('.slick-gallery-nav__count__cur').text(formattedNextSlide);
    });
  });
  for (let i = 0; i < captions.length; i++) {
    captionsContainer.append( captions[i] );
  }
}

// LANDING ANIMATION
const images = document.querySelectorAll(".landing-animation__svg");
const landingAnimation = document.querySelector(".landing-animation");
const headerLogoInner = document.querySelectorAll(".site-header__logo, .site-header__inner");

if ( landingAnimation !== null ) {
  document.body.style.overflow = 'hidden';
  headerLogoInner.forEach(element => {
      element.style.opacity = 0;
  });
}

function showSequentially(index) {
    if (index < images.length) {
        images[index].style.opacity = 1;
        setTimeout(function () {
            images[index].style.opacity = 0;
            showSequentially(index + 1);
        }, 500); 
    } else {
      landingAnimation.style.opacity = 0; 
        setTimeout(function () {
            landingAnimation.style.display = "none"; 
        }, 500); 
        document.body.style.overflow = 'visible';

      headerLogoInner.forEach(element => {
        element.style.transition = 'opacity 300ms';
        element.style.opacity = 1;
    });
    }
}

window.addEventListener("load", function () {
  if ( landingAnimation !== null ) {
    setTimeout(function () {
          document.body.style.overflow = 'hidden';
          showSequentially(0);
    }, 0);
  }
});



